import {
  AccordionContent,
  AccordionItem,
} from "@/components/reusables/ui/accordion"
import { Body, H6 } from "@/components/standard/BFText"
import { AccordionHeader } from "@/screens/loans/components/setup/AccordionHeader"
import { Pressable, View } from "react-native"

import { BFColors } from "@/constants/Colors"
import { Container } from "@/screens/rewards/components/Container"
import { Horizontal } from "@/components/standard/BFLayout"
import CheckCircle from "phosphor-react-native/src/icons/CheckCircle"
import Circle from "phosphor-react-native/src/icons/Circle"

export const CONTRACT_STATUS_QUESTIONS = [
  {
    value: "under-contract",
    label: "Under contract",
  },
  {
    value: "this-week",
    label: "This week",
  },
  {
    value: "1-2-weeks",
    label: "1-2 weeks",
  },
  {
    value: "2-plus-weeks",
    label: "2+ weeks",
  },
  {
    value: "refinance",
    label: "This is a refinance",
  },
  {
    value: "unknown",
    label: "No contract expected",
  },
]

export const ContractStatusQuestions = ({
  contractStatus,
  onChange,
}: {
  contractStatus: string | undefined
  onChange: (contractStatus?: string) => void
}) => {
  let value = CONTRACT_STATUS_QUESTIONS.find(
    (q) => q.value === contractStatus
  )?.label
  if (value === "Under contract") {
    value = "Currently under contract"
  }
  return (
    <AccordionItem value={"contract-status"}>
      <AccordionHeader text={"Contract Status"} value={value} />
      <AccordionContent>
        <View>
          <Body color={"primary"}>
            When do you expect to be under contract?
          </Body>
          <Container className={"p-0"}>
            {CONTRACT_STATUS_QUESTIONS.map((option, index) => {
              return (
                <Pressable
                  testID={`$contract-status-option-${index}`}
                  key={option.value}
                  className={"hover:bg-grey py-1 px-4"}
                  onPress={() => {
                    onChange(option.value)
                  }}
                >
                  <Horizontal
                    key={option.value}
                    className={"justify-between items-center py-2"}
                  >
                    <H6 key={option.value}>{option.label}</H6>

                    {contractStatus === option.value ? (
                      <CheckCircle
                        color={BFColors.calmBlue}
                        size={20}
                        weight="fill"
                      />
                    ) : (
                      <Circle color={BFColors.calmBlue} size={20} />
                    )}
                  </Horizontal>
                </Pressable>
              )
            })}
          </Container>
        </View>
      </AccordionContent>
    </AccordionItem>
  )
}
